import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es827.js";
const m = {
  name: e.spanish,
  locale: o
};
export {
  m as date_es
};
